/**
 * 全局 session 管理：session_id 用于埋点公共属性、请求统一注入与重定向拼接；
 * sessionDuration 用于统计会话时长。存取统一走 sessionStorage（见 caches/session）。
 */

import { createTraceID } from './traceId'
import {
  getSessionIdCache,
  getSessionStartTimeCache,
  setSessionIdCache,
  setSessionStartTimeCache,
  removeSessionIdCache,
  removeSessionStartTimeCache,
} from '../caches/session'

/** 创建一个新的 session */
export function initSession(id?: string): string {
  // 初始化 session 起始时间
  initSessionDuration()

  // 如果传入了 session_id，则直接使用，否则创建新的
  const _id = id || createSessionId()
  setSessionIdCache(_id)

  return _id
}

/** 创建一个新的 session_id */
export function createSessionId() {
  return createTraceID()
}

/** 清除 session */
export function clearSession() {
  removeSessionIdCache()
  removeSessionStartTimeCache()
}

/** 获取当前 session_id；未初始化时返回 undefined */
export function getSessionId(): string | undefined {
  return getSessionIdCache()
}

/** 初始化 session 起始时间并写入缓存，返回当前时间戳（毫秒） */
export function initSessionDuration(): number {
  const startTime = Date.now()
  setSessionStartTimeCache(startTime)
  return startTime
}

/** 获取 session 已持续时长（毫秒）；未初始化时返回 0 */
export function getSessionDuration(): number {
  const startTime = getSessionStartTimeCache()
  if (startTime === undefined) return 0
  return Date.now() - startTime
}
